<template>
  <div id="History">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title v-if="userLogged.roles && userLogged.roles[0].id === 2">
          <v-spacer/>
            <v-btn @click="filterModal = true"
              color="primary">
              {{$t('reports.filter')}}
              <v-icon small class="ml-2">
                fas fa-align-center
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="inspections"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get"
            >
              <template v-slot:item="props" >
                <tr>
                  <td align="left">{{props.item.created_at ? props.item.created_at : '--'}}</td>
                  <td align="left">{{props.item.name ? props.item.name : '--'}}</td>
                  <td align="left">{{props.item.user && props.item.user.name ? props.item.user.name : '--'}}</td>
                  <td align="left" v-if="props.item.truck !== null">
                    {{props.item.truck && props.item.truck.vin_number ? props.item.truck.vin_number : '--'}}
                  </td>
                  <td align="left" v-if="props.item.truck === null && props.item.container !== null">
                    {{props.item.container && props.item.container.vin_number ? props.item.container.vin_number : '--'}}
                  </td>
                  <td align="left">{{props.item.duration ? props.item.duration : '--'}}</td>
                  <td align="left">{{props.item.site && props.item.site.name ? props.item.site.name : '--'}}</td>
                  <td align="left">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-icon class="mr-4" small @click="view(props.item.id)" v-on="on">far fa-eye</v-icon>
                      </template>
                      <span>{{$t('general.view')}}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      max-width="500px"
      persistent
      v-model="filterModal">
      <v-card>
        <v-card-title>
          <span class="primary--text">{{$t('reports.filter')}}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form
            lazy-validation
            ref="form"
            v-model="valid">
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="sites"
                  item-text="name"
                  item-value="id"
                  v-model="filter.site_id"
                  :label="$t('general.site')"
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="unitTypes"
                  item-text="alias"
                  item-value="id"
                  v-model="filter.unit_type_id"
                  :label="$t('general.unitType')"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  :label="$t('general.plates')"
                  v-model="filter.plate"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  :label="$t('general.unitNumber')"
                  v-model="filter.unit_number"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="VIN"
                  v-model="filter.vin_number"
                />
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.start_date"
                      :label="$t('general.startDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      :error-messages="filter.start_date ? '' : $t('validation.startDate')"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker no-title color="primary" v-model="filter.start_date" @input="menu = false"/>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.end_date"
                      :label="$t('general.endDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      :required="$t('validation.endDate')"
                      :error-messages="filter.end_date ? '' : $t('validation.endDate')"
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker no-title color="primary" v-model="filter.end_date" @input="menu2 = false"/>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-btn
                  depressed
                  class="float-right"
                  @click="getFilter"
                  color="primary">
                  {{$t('general.save')}}
                </v-btn>
                <v-btn
                  class="float-right mr-2"
                  outlined
                  @click="filterModal = false"
                  color="primary">
                  {{$t('general.cancel')}}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Inspections',
  data () {
    return {
      sites: [],
      unitTypes: [],
      filterModal: false,
      menu: false,
      menu2: false,
      loadTable: true,
      valid: false,
      addDialog: false,
      dialog: false,
      search: '',
      pageCount: 0,
      filter: {
        site_id: null,
        unit_type_id: null,
        plate: null,
        unit_number: null,
        vin_number: null,
        dateRange: true,
        start_date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${
          new Date(new Date().getFullYear(), new Date().getMonth(), 1).getDate() < 10 ? '0'+new Date(new Date().getFullYear(), new Date().getMonth(), 1).getDate() :
          new Date(new Date().getFullYear(), new Date().getMonth(), 1).getDate()
          }`,
        end_date: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate()}`
      },
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      inspections: [],
    }
  },
  computed: {
    userLogged () {
      return this.$store.state.userLogged
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
           text: this.$t('general.date'),
           value: 'created_at',
           sortable: true,
           align: 'left'
        },
        {
          text: this.$t('general.name'),
          value: 'name',
          sortable: true,
          align: 'left'
        },
        {
          text: this.$t('general.user'),
          value: 'user',
          sortable: true,
          align: 'left'
        },
        {
          text: this.$t('general.unit'),
          value: 'truck',
          sortable: true,
          align: 'left'
        },
        {
          text: this.$t('general.duration'),
          value: 'duration',
          sortable: true,
          align: 'left'
        },
        {
          text: this.$t('general.site'),
          value: 'site',
          sortable: true,
          align: 'left'
        },
        {
          text: this.$t('general.actions'),
          sortable: false,
          align: 'left'
        }
      ]
    }
  },
  watch: {
    userLogged () {
      if (this.userLogged.roles) {
        this.get()
        this.getOnlyAdmin()
      }
    }
  },
  created () {
    this.get()
    this.getOnlyAdmin()
  },
  methods: {
    getFilter () {
      this.get()
      this.filterModal = false
    },
    close () {
      this.dialog = false
      this.addDialog = false,
      this.editedItem = Object.assign({}, this.defaultItem)
      this.removedItem = {}
      this.$refs.form.resetValidation()
    },
    view (id) {
      this.$router.push('history/view/' + id)
    },
    get () {
      this.loadTable = true
      if (this.userLogged.roles) {
        this.$store.dispatch('inspections/get', {
          event:{
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
            ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
            type: 'json',
            context:this,
            filter: this.filter
          }
        })
      }
    },
    getOnlyAdmin () {
      if (this.userLogged.roles && this.userLogged.roles[0].id === 2) {
      this.$store.dispatch('sites/get', {
        event: {
          context: this,
          all: true,
          item: {
            perPage: -1,
            page: 1
          }
        }
      })
      this.$store.dispatch('unitTypes/getAll', {
        event: {
          context: this
        }
      })
    }
    }
  }
}
</script>